package com.rosario.juridico.domain.model

import org.jetbrains.compose.resources.ExperimentalResourceApi
import juridico5.composeapp.generated.resources.Res

data class PasoProcedimientoPromesa(
    val id: Int,
    val titulo: String,
    val actor: String,
    val accion: String,
    val plazoHorario: String,
    val alerta: String?,
    val opciones: List<String> = emptyList()
)

object PromesaParser {
    suspend fun cargarPasos(): List<PasoProcedimientoPromesa> {
        return try {
            val contenido = Res.readBytes("files/promesa_procesal_base.txt").decodeToString()
            parsearContenido(contenido)
        } catch (e: Exception) {
            emptyList()
        }
    }

    private fun parsearContenido(contenido: String): List<PasoProcedimientoPromesa> {
        val pasos = mutableListOf<PasoProcedimientoPromesa>()
        val bloques = contenido.split(Regex("\\[PASO_\\d+\\]"))
        
        bloques.filter { it.isNotBlank() }.forEachIndexed { index, bloque ->
            val lineas = bloque.trim().lines()
            var titulo = ""
            var actor = ""
            var accion = ""
            var plazo = ""
            var alerta: String? = null
            val opciones = mutableListOf<String>()

            lineas.forEach { linea ->
                val l = linea.trim()
                when {
                    l.startsWith("TITULO:") -> titulo = l.removePrefix("TITULO:").trim()
                    l.startsWith("ACTOR:") -> actor = l.removePrefix("ACTOR:").trim()
                    l.startsWith("ACCION:") -> accion = l.removePrefix("ACCION:").trim()
                    l.startsWith("PLAZO_HORARIO:") -> plazo = l.removePrefix("PLAZO_HORARIO:").trim()
                    l.startsWith("ALERTA:") -> alerta = l.removePrefix("ALERTA:").trim().takeIf { it.isNotBlank() }
                    l.startsWith("OPCION_") -> opciones.add(l.substringAfter(":").trim())
                }
            }

            if (titulo.isNotBlank()) {
                pasos.add(
                    PasoProcedimientoPromesa(
                        id = index + 1,
                        titulo = titulo,
                        actor = actor,
                        accion = accion,
                        plazoHorario = plazo,
                        alerta = alerta,
                        opciones = opciones
                    )
                )
            }
        }
        return pasos
    }
}
